var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more bg-white min-main border-black items-center justify-between",on:{"click":function($event){return _vm.toArticle(20)}}},[_c('div'),_vm._v(" "),_c('h3',{staticClass:"font16"},[_vm._t("default")],2),_vm._v(" "),_c('svg-icon',{attrs:{"icon-class":"Path 2492"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21330960","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/expert/more.vue
// module id = null
// module chunks = 